import "./ResilientImage.css";
import { useResilientImageSrc } from "./useResilientImageSrc";

function ResilientImage({
    src,
    alt = "",
    className,
    loading,
    decoding,
    fetchPriority,
    placeholderClassName = "resilient-image-placeholder",
}) {
    const { src: resolvedSrc, handleError, failed } = useResilientImageSrc(src);

    if (failed) {
        return (
            <div
                className={placeholderClassName}
                role="img"
                aria-label={alt}
            />
        );
    }

    return (
        <img
            key={resolvedSrc}
            src={resolvedSrc}
            alt={alt}
            className={className}
            loading={loading}
            decoding={decoding}
            fetchPriority={fetchPriority}
            onError={handleError}
        />
    );
}

export default ResilientImage;
